import {RouterProvider} from 'react-router-dom'
import {router} from './router.tsx'
import Toaster from './Toaster.tsx'

export default function App() {
    return (
        <>
            <Toaster />
            <RouterProvider router={router} />
        </>
    )
}
